import { LoggerInstance } from 'global-logger-services-js/global-logger-services-js-bundle';
import { SingletonSharedData } from '../Singletons/SingletonSharedData'

LoggerInstance.setApplication("[SDK-Kolob]");

export class Logger {
	static getUserID() {
		var sharedData = new SingletonSharedData();
		var user = sharedData.getParameters();
		var userId = user ? user.UserID : 0;
		LoggerInstance.setUserId(userId);
		return userId;
	}

	setUserType(userType) {
		Logger.setUserType(userType);
	}

	static setUserId(userId) {
		LoggerInstance.setUserId(userId);
	}

	static Trace(...msg) {
		LoggerInstance.Trace([`[SDK-Kolob]`, ...msg]);
	}

	static Debug(...msg) {

		LoggerInstance.Debug([`[SDK-Kolob]`, ...msg]);
	}

	static Warning(...msg) {
		LoggerInstance.Warning([`[SDK-Kolob]`, ...msg]);
	}

	static Warn(...msg) {
		LoggerInstance.Warning([`[SDK-Kolob]`, ...msg]);
	}

	static Info(...msg) {
		LoggerInstance.Info([`[SDK-Kolob]`, ...msg]);
	}

	static Error(...msg) {
		LoggerInstance.Error(`[SDK-Kolob]lib[UserID:${Logger.getUserID()}]`, ...msg);
	}

	static JsError(...msg) {
		LoggerInstance.JsError(`[SDK-Kolob]lib[UserID:${Logger.getUserID()}]`, ...msg);
	}

	static JsWarning(...msg) {
		LoggerInstance.JsWarning([`[SDK-Kolob]`, ...msg]);
	}

	static EnableLocalLog(enabled, time) {
		LoggerInstance.setLocalLogger(enabled);
		enabled && LoggerInstance.setLocalStorageTime(time);
	}
}